export const sectionOne = {
  reverse: true,
  inverse: true,
  topLine: "Founded in 2012",
  headline: "We've been in business for 9 years",
  description:
    "We have designed and implemented the best cloud security solutions",
  buttonLabel: "Find More",
  imgStart: "start",
  img: "./assets/music-chill.svg",
  start: "true",
};

export const sectionTwo = {
  reverse: false,
  inverse: false,
  topLine: "Designed & Developed",
  headline: "The best practices",
  description: "Our clients have had the best experience working with us",
  buttonLabel: "View Project",

  linkTo: "/more",
  imgStart: "start",
  img: "./assets/music-logo.svg",
  start: "true",
};

export const sectionThree = {
  reverse: true,
  inverse: true,
  topLine: "Highly reputed brand",
  headline: "Why us? ",
  description:
    "Our 9 year experience have allowed us to use the most innovative technologies and methodologies",
  buttonLabel: "View Project",

  linkTo: "/download",
  imgStart: "",
  img: "./assets/music-relax.svg",
  start: "true",
};
